(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hc-city-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!('IntersectionObserver' in window)) return;
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const seen = new WeakSet();
    const waiting = new Set();
    const active = new Map();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting || !waiting.has(target)) return;
        observer.unobserve(target);
        waiting.delete(target);
        target.dataset.cityRevealed = 'true';
        if (preference.matches || !target.animate) return;
        const photo = target.dataset.cityReveal === 'photo';
        const animation = target.animate(photo ? [
          { clipPath: 'inset(8% 0 8% 0)', opacity: .75 },
          { clipPath: 'inset(0% 0 0% 0)', opacity: 1 }
        ] : [
          { opacity: .65, transform: 'translateY(10px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: photo ? 720 : 520, delay: Math.min(Number(target.dataset.citySequence) || 0, 3) * 65, easing: 'cubic-bezier(.22,1,.36,1)' });
        active.set(target, animation);
        const finish = () => { if (active.get(target) === animation) active.delete(target); };
        animation.finished.then(finish, finish);
      });
    }, { threshold: .15 });
    const initialize = (root) => {
      root.querySelectorAll('[data-city-reveal]').forEach((element) => {
        if (seen.has(element)) return;
        seen.add(element);
        waiting.add(element);
        observer.observe(element);
      });
    };
    const cancelWithin = (root) => {
      active.forEach((animation, element) => {
        if (root.contains(element)) { animation.cancel(); active.delete(element); }
      });
    };
    preference.addEventListener('change', () => { if (preference.matches) cancelWithin(document); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) cancelWithin(document); });
    document.addEventListener('focusin', (event) => {
      active.forEach((animation, element) => { if (element.contains(event.target)) animation.cancel(); });
    });
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      cancelWithin(event.target);
      waiting.forEach((element) => {
        if (event.target.contains(element)) { observer.unobserve(element); waiting.delete(element); }
      });
    });
    initialize(document);
  })();
  } catch(e) { console.error(e); }
})();

})();
